import Vue from "vue";
import Component from "vue-class-component";
import * as url from "url";
import { UrlWithStringQuery } from "url";

@Component
export default class ShareSdk extends Vue {
  protected baseUrl() {
    const urlObj: UrlWithStringQuery = url.parse(window.location.href);
    return url.format({
      hostname: urlObj.hostname,
      protocol: urlObj.protocol,
      port: urlObj.port,
    });
  }

  protected suggestShareData(): {
    title: string;
    desc?: string;
    link: string;
    imgUrl: string;
  } {
    const defaultImgUrl: string = this.baseUrl() + require("@/assets/logo.png");
    const images: HTMLCollectionOf<HTMLImageElement> = window.document.images;
    let sgimgUrl: string = defaultImgUrl;
    for (const image of images) {
      if (image.height >= 200 && image.width >= 200) {
        sgimgUrl = image.src;
      }
    }
    return {
      title: document.title,
      desc: "",
      link: window.location.href,
      imgUrl: sgimgUrl,
    };
  }

  protected getPlainTxt(input: string) {
    return input
      .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, "")
      .replace(/<[^>]+?>/g, "")
      .replace(/\s+/g, " ")
      .replace(/ /g, " ")
      .replace(/>/g, " ");
  }

  protected getDesc(input: string) {
    const text = this.getPlainTxt(input);
    return text.length > 50 ? text.substr(0, 50) + "..." : text;
  }
}
